"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* globals module */
/**
 * @module registerRoute
 * @description Baasic Register Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Register Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var RegisterRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RegisterRoute, _super);
    function RegisterRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'register';
        /**
        * Activate route with route and query parameters.
        **/
        _this.activateRoute = 'activate/{activationToken}/';
        /**
        * Recovery route with route and query parameters.
        **/
        _this.recoveryRoute = 'recovery/{email}/';
        return _this;
    }
    /**
     * Parses register route, this route doesn't support any additional properties.
     * @method
     * @example registerRoute.create();
     **/
    RegisterRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses activation route; route should be expanded with the `activationToken` which uniquely identifies the user account that needs to be activated.
     * @method
     * @param data Security code which uniquely identifies user account that needs to be activated.
     * @example registerRoute.activate({activationToken: '<activation-token>'});
     **/
    RegisterRoute.prototype.activate = function (data) {
        var params = this.modelMapper.getParams(data, undefined, 'activationToken');
        return _super.prototype.baseCreate.call(this, this.activateRoute, params);
    };
    /**
     * Parses recovery route; route should be expanded with the `email` which uniquely identifies the user account that needs email recovery to be resent.
     * @method
     * @param data User email which uniquely identifies user account that needs password recovery resent.
     * @example registerRoute.recovery({email: '<email>'});
     **/
    RegisterRoute.prototype.recovery = function (data) {
        var params = this.modelMapper.getParams(data, undefined, 'email');
        return _super.prototype.baseCreate.call(this, this.recoveryRoute, params);
    };
    var _a;
    RegisterRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], RegisterRoute);
    return RegisterRoute;
}(common_1.BaseRoute));
exports.RegisterRoute = RegisterRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
